import { render, staticRenderFns } from "./StatusPanel.vue?vue&type=template&id=6d0cc632&scoped=true&"
import script from "./StatusPanel.vue?vue&type=script&lang=js&"
export * from "./StatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatusPanel.vue?vue&type=style&index=0&id=6d0cc632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cc632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0cc632')) {
      api.createRecord('6d0cc632', component.options)
    } else {
      api.reload('6d0cc632', component.options)
    }
    module.hot.accept("./StatusPanel.vue?vue&type=template&id=6d0cc632&scoped=true&", function () {
      api.rerender('6d0cc632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatusPanel.vue"
export default component.exports